// Get API URL based on environment
const getApiBaseUrl = () => {
  // In development mode, use the proxy to avoid CORS issues
  if (import.meta.env.DEV) {
    console.log('🔧 Development mode - using proxy: /api/v1');
    return '/api/v1';
  }
  
  // In production mode, use the full API URL
  if (import.meta.env.VITE_SECONDLANE_API_URL) {
    const apiUrl = `${import.meta.env.VITE_SECONDLANE_API_URL}/api/v1`;
    console.log('🔧 Production mode - using full API URL:', apiUrl);
    return apiUrl;
  }
  
  // Fallback
  console.log('🔧 Fallback - using proxy: /api/v1');
  return '/api/v1';
}

export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  TIMEOUT: 10000,
  RETRY_ATTEMPTS: 3,
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
} 